export default "__VITE_ASSET__dhW$hUKh__"